import { createAction, props } from '@ngrx/store';

import { PagedResponse, SortOptions } from '../general/models/general';
import { createFailure, createSuccess } from '../utils/action-utils';
import {
  IAssociatedEntities,
  IVulnerability,
  IVulnerabilityAsset,
  IVulnerabilityOccurence,
  IVulnerabilityOverview,
} from './models/Vulnerability';

// Get Vulnerabilities Actions //
const getVulnerabilitiesKey = '[Vulnerabilities] Get Vulnerabilities';
export const getVulnerabilities = createAction(
  getVulnerabilitiesKey,
  props<{
    sortOptions?: SortOptions;
    searchTerm?: string;
    filters?: string;
    pageNumber: number;
    query?: Record<string, string>;
  }>(),
);
export const getVulnerabilitiesSuccess = createAction(
  createSuccess(getVulnerabilitiesKey),
  props<{ pagedVulnerabilities: PagedResponse<IVulnerability> }>(),
);
export const getVulnerabilitiesFailure = createAction(
  createFailure(getVulnerabilitiesKey),
  props<{ error: any }>(),
);

// Get Vulnerability By Id Actions //
const getVulnerabilityByIdKey = '[Vulnerabilities] Get Vulnerability By Id';
export const getVulnerabilityById = createAction(
  getVulnerabilityByIdKey,
  props<{ id: string }>(),
);
export const getVulnerabilityByIdSuccess = createAction(
  createSuccess(getVulnerabilityByIdKey),
  props<{ vulnerabilityById: IVulnerabilityOverview }>(),
);
export const getVulnerabilityByIdFailure = createAction(
  createFailure(getVulnerabilityByIdKey),
  props<{ error: any }>(),
);

// Get Vulnerabilities Assets Actions //
const getVulnerabilitiesAssetsKey = '[Vulnerabilities] Get Assets';
export const getVulnerabilitiesAssets = createAction(
  getVulnerabilitiesAssetsKey,
);
export const getVulnerabilitiesAssetsSuccess = createAction(
  createSuccess(getVulnerabilitiesAssetsKey),
  props<{ vulnerabilitiesAssets: IVulnerabilityAsset[] }>(),
);
export const getVulnerabilitiesAssetsFailure = createAction(
  createFailure(getVulnerabilitiesAssetsKey),
  props<{ error: any }>(),
);

// Resolve Vulnerability Actions //
const resolveVulnerabilityKey = '[Vulnerabilities] Resolve Vulnerability';
export const resolveVulnerability = createAction(
  resolveVulnerabilityKey,
  props<{ vulnerabilityId: string }>(),
);
export const resolveVulnerabilitySuccess = createAction(
  createSuccess(resolveVulnerabilityKey),
  props<{ vulnerabilityId: string }>(),
);
export const resolveVulnerabilityFailure = createAction(
  createFailure(resolveVulnerabilityKey),
  props<{ error: any }>(),
);

// Unresolve Vulnerability Actions //
const unresolveVulnerabilityKey = '[Vulnerabilities] Un-resolve Vulnerability';
export const unresolveVulnerability = createAction(
  unresolveVulnerabilityKey,
  props<{ vulnerabilityId: string }>(),
);
export const unresolveVulnerabilitySuccess = createAction(
  createSuccess(unresolveVulnerabilityKey),
  props<{ vulnerabilityId: string }>(),
);
export const unresolveVulnerabilityFailure = createAction(
  createFailure(unresolveVulnerabilityKey),
  props<{ error: any }>(),
);

// Calculate Vulnerability Risk Actions //
const calculateVulnerabilityRiskKey = '[Vulnerabilities] Calculate Risk';
export const calculateVulnerabilityRisk = createAction(
  calculateVulnerabilityRiskKey,
  props<{ vulnerabilityId: string }>(),
);
export const calculateVulnerabilityRiskSuccess = createAction(
  createSuccess(calculateVulnerabilityRiskKey),
  props<{ vulnerabilityId: string }>(),
);
export const calculateVulnerabilityRiskFailure = createAction(
  createFailure(calculateVulnerabilityRiskKey),
  props<{ error: any }>(),
);

// Vulnerability Associated Entities Actions //
const vulnerabilityAssociatedEntitiesKey =
  '[Vulnerabilities] Associated Entities';
export const vulnerabilityAssociatedEntities = createAction(
  vulnerabilityAssociatedEntitiesKey,
  props<{ vulnerabilityId: string }>(),
);
export const vulnerabilityAssociatedEntitiesSuccess = createAction(
  createSuccess(vulnerabilityAssociatedEntitiesKey),
  props<{ associatedEntities: IAssociatedEntities }>(),
);
export const vulnerabilityAssociatedEntitiesFailure = createAction(
  createFailure(vulnerabilityAssociatedEntitiesKey),
  props<{ error: any }>(),
);

// Get Vulnerability Occurrences Actions //
const getVulnerabilityOccurencesKey = '[Vulnerabilities] Get Occurences';
export const getVulnerabilityOccurences = createAction(
  getVulnerabilityOccurencesKey,
  props<{ vulnerabilityId: string; pageNumber: number }>(),
);
export const getVulnerabilityOccurencesSuccess = createAction(
  createSuccess(getVulnerabilityOccurencesKey),
  props<{
    pagedVulnerabilityOccurences: PagedResponse<IVulnerabilityOccurence>;
  }>(),
);
export const getVulnerabilityOccurencesFailure = createAction(
  createFailure(getVulnerabilityOccurencesKey),
  props<{ error: any }>(),
);

// Resolve Occurrence Actions //
const resolveOccurrenceKey = '[Vulnerabilities] Resolve Occurrence';
export const resolveOccurrence = createAction(
  resolveOccurrenceKey,
  props<{ vulnerabilityId: string; occurrenceId: string }>(),
);
export const resolveOccurrenceSuccess = createAction(
  createSuccess(resolveOccurrenceKey),
  props<{ vulnerabilityId: string; occurrenceId: string }>(),
);
export const resolveOccurrenceFailure = createAction(
  createFailure(resolveOccurrenceKey),
  props<{ error: any }>(),
);

// Unresolve Occurrence Actions //
const unresolveOccurrenceKey = '[Vulnerabilities] Un-resolve Occurrence';
export const unresolveOccurrence = createAction(
  unresolveOccurrenceKey,
  props<{ vulnerabilityId: string; occurrenceId: string }>(),
);
export const unresolveOccurrenceSuccess = createAction(
  createSuccess(unresolveOccurrenceKey),
  props<{ vulnerabilityId: string; occurrenceId: string }>(),
);
export const unresolveOccurrenceFailure = createAction(
  createFailure(unresolveOccurrenceKey),
  props<{ error: any }>(),
);
